import { NgModule } from '@angular/core';

import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { SharedModule } from '../../shared';

import { ItemFilterModalComponent } from './filter';
import { TypeaheadItemComponent } from './typeahead';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule.forRoot(),
    ],
    declarations: [
        ItemFilterModalComponent,
        TypeaheadItemComponent,
    ],
    exports: [
        SharedModule,

        ItemFilterModalComponent,
        TypeaheadItemComponent,
    ]
})
export class ItemSharedModule { }
